module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-3.55815546.jpg";